import { gql } from "@apollo/client";

export const typeDefs = gql`
  scalar Long
`;
